import React from "react";
import styled from "styled-components";
import { monogram } from "../MVP/home/primitives";

/* Общие кирпичи админки: те же токены, что и в приложении, плотнее строки и подписи. */
export const Surface = styled.section`
  min-width: 0;
  padding: 24px;
  border-radius: 16px;
  background: ${(p) => p.theme.colors.surface};
  @media (max-width: 767px) {
    padding: 16px;
  }
  h2 {
    font-size: 18px;
    line-height: 26px;
    font-weight: 600;
  }
`;
export const Toolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  margin-bottom: 16px;
  .grow {
    flex: 1 1 260px;
    min-width: 0;
  }
  .count {
    margin-left: auto;
    font-size: 14px;
    color: ${(p) => p.theme.colors.textMuted};
    font-variant-numeric: tabular-nums;
  }
`;
export const Chip = styled.span<{ $tone?: "ok" | "info" | "warn" | "muted" }>`
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 0 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  color: ${(p) =>
    p.$tone === "ok" ? p.theme.colors.success : p.$tone === "warn" ? p.theme.colors.warning : p.$tone === "info" ? p.theme.colors.info : p.theme.colors.textSecondary};
  background: ${(p) =>
    p.$tone === "ok" ? p.theme.colors.successSoft : p.$tone === "warn" ? p.theme.colors.warningSoft : p.$tone === "info" ? p.theme.colors.infoSoft : p.theme.colors.surfaceHover};
`;
export const Rows = styled.ul`
  list-style: none;
  display: grid;
  margin: 0 -8px;
  > li {
    display: grid;
    align-items: center;
    gap: 12px 16px;
    min-height: 60px;
    padding: 8px;
    border-radius: 10px;
    transition: background ${(p) => p.theme.motion.fast};
    &:hover {
      background: ${(p) => p.theme.colors.raised};
    }
  }
  .name {
    min-width: 0;
    font-size: 15px;
    line-height: 20px;
    font-weight: 600;
    overflow-wrap: anywhere;
  }
  .sub {
    font-size: 13px;
    line-height: 18px;
    color: ${(p) => p.theme.colors.textMuted};
    overflow-wrap: anywhere;
  }
  .num {
    font-variant-numeric: tabular-nums;
  }
`;
export const Av = styled.span`
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  background: ${(p) => p.theme.colors.surfaceHover};
  color: ${(p) => p.theme.colors.textSecondary};
  font-size: 14px;
  font-weight: 650;
`;
export function Identity({ name, sub }: { name: string; sub?: string }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 0 }}>
      <Av aria-hidden="true">{monogram(name)}</Av>
      <div style={{ minWidth: 0 }}>
        <div className="name">{name}</div>
        {sub && <div className="sub">{sub}</div>}
      </div>
    </div>
  );
}
export const Pager = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 16px;
  margin-top: 16px;
  font-size: 14px;
  color: ${(p) => p.theme.colors.textMuted};
  .btns {
    display: flex;
    gap: 8px;
  }
`;
export const Unavailable = styled.div`
  display: grid;
  justify-items: start;
  gap: 8px;
  max-width: 64ch;
  h2 {
    font-size: 20px;
    line-height: 28px;
  }
  p {
    font-size: 15px;
    line-height: 22px;
    color: ${(p) => p.theme.colors.textSecondary};
  }
`;
export const Err = styled.p`
  font-size: 14px;
  color: ${(p) => p.theme.colors.danger};
`;

/** Загрузочные ошибки админки хранят код статуса; в интерфейсе нужен смысл, а не число. */
export function adminErrorText(code: string, t: (k: string) => string): string {
  if (code === "401" || code === "403") return t("sys.forbidden_text");
  if (/^\d+$/.test(code) || code === "error") return t("sys.temporary");
  return code;
}
